
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkTaskTabColumnEnum } from '../models/work-task-tab-column-enum';
import { WorkTaskTabSortEnum } from '../models/work-task-tab-sort-enum';

export function getUpdateTaskTabDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>('', [Validators.maxLength(100)]),
    roletypeIds: new FormControl<Array<number> | undefined>([]),
    standardtaskIds: new FormControl<Array<number> | undefined>([]),
    columns: new FormControl<WorkTaskTabColumnEnum[]>([]),
    sortBy: new FormControl<WorkTaskTabSortEnum | undefined>(undefined),
    dueRequired: new FormControl<boolean | undefined>(undefined),
    onlyInFocus: new FormControl<boolean | undefined>(undefined),
    hideWhenEmpty: new FormControl<boolean | undefined>(undefined),
    onlyOwnTasks: new FormControl<boolean | undefined>(undefined),
    showOverdue: new FormControl<boolean | undefined>(undefined),
})
;
}
      